let callbackMap = {}
const u = navigator.userAgent;
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

export default {
  getNextMsgId(method) {
    return method + new Date().getTime()
  },
  executeMobile(method, params, callback) {
    let data = {
      callbackId: null,
      params: params
    }

    if (callback) {
      let callbackId = this.getNextMsgId(method)
      data.callbackId = callbackId
      callbackMap[callbackId] = callback
    }

    if (isAndroid) {
			if (window.$android && window.$android.native) {
		
    // 安全调用 Android 接口
        return window.$android.native(method, JSON.stringify(data))
			}
			else if (window.$android && typeof window.$android.nativecall === 'function') {
						// 安全调用 Android 接口
					return window.$android.nativecall(method, JSON.stringify(data))
			}
		  else {
          console.log('Android 接口不可用，可能不在 Android WebView 环境中');
					// 提供备选方案或提示用户
					// 提供备选方案或提示用户
					if (callback) {
							callback("");
					}
     }
     
    } else if (isIOS) {
			if (window.webkit && window.webkit.messageHandlers){
				 return window.webkit.messageHandlers[method].postMessage(JSON.stringify(data))
			}
			 else {
          console.log('IOS 接口不可用，可能不在 IOS WebView 环境中');
					// 提供备选方案或提示用户
					if (callback) {
							callback("");
					}
     }
    }
  },
  init() {
    window.$mobile = {}
    window.$mobile.callback = (params) => {
      let id = params.callbackId
      let callback = callbackMap[id]
      if (callback) {
        delete callbackMap[id]
        callback(params.params)
      }
    }
    window.$mobile.scanQRCode = (type, callback) => this.executeMobile('scanQRCode', type, callback)
    window.$mobile.logger = (msg) => this.executeMobile('logger', msg)
    window.$mobile.open = (url) => this.executeMobile('open', url)
    window.$mobile.navigationShow = (isShow) => this.executeMobile('navigationShow', isShow)
    window.$mobile.navigationTo = (index) => this.executeMobile('navigationTo', index) //0 1 2
    window.$mobile.showMine = () => this.executeMobile('showMine')
    window.$mobile.close = () => this.executeMobile('close')
    window.$mobile.navigationBarShow = (isShow) => this.executeMobile('naviBarShow',isShow)
    window.$mobile.saveRecycleQrCode = (params, callback) => this.executeMobile('saveRecycleQrCode', params, callback)
    window.$mobile.showMap = (params) =>  this.executeMobile('showMap', params)
    window.$mobile.getCurrentStoreID = (type,callback) => this.executeMobile('getCurrentStoreID',type,callback) //获取当前门店
  }
}



// WEBPACK FOOTER //
// ./src/common/MobileApi.js